module.exports = __webpack_public_path__ + "static/media/google-play-image.3251dbc9.png";